/*
    use the Popper library to display a modal form listing all
    current stored phrases used for messages, so that the user
    can select one to use

    the user can also freely enter any text to save as a new such message
*/

import React, { useState, useContext, useEffect } from 'react';
import { usePopper } from 'react-popper';

import MainContext from "../MainContext";

import StoredMessageData from "../DataDisplay/StoredMessageData";

import { 
    getStoredMessages,
    addStoredMessage,
    updateStoredMessage,
    deleteStoredMessage
} from "../Requests/MessageRequests";

// const width = 40;

const StoredMessagesModal = (props) => {
    const context = useContext(MainContext);

    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const [show, setShow] = useState(false);

    const [phrase, setPhrase] = useState(props.phrase);
    const [allPhrases, setAllPhrases] = useState([]);

    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        -332, 
                        -50
                    ]
                }
            }
        ]
    });

    //
    // toggle whether we show the modal with all of the stored messages
    //
    const buttonClick = () => {
        console.log("BUTTON CLICK", show);
        setShow(!show);
    }

    //
    // called when the user types in the message textarea
    //
    const typePhrase = (evt) => {
        setPhrase(evt.target.value);
    }

    //
    //
    const getMessages = () => {
        const request = () => getStoredMessages();
        const then = ({data}) => {
            console.log("STORED MESSAGES", data);
            setAllPhrases(data);
            // force it to jump into the frame if it's too far off
            window.scroll(0, 1);
            window.scroll(0, 0);
        };
        context.runProcessing(request, then, "getStoredMessages");
    }

    //
    // reload the data when show is set to true
    //
    useEffect(() => {
        setAllPhrases([]);

        if(show){
            console.log("USE EFFECTS");
            getMessages();
        }
    }, [show]);

    //
    //
    const saveMessage = () => {
        const request = () => addStoredMessage(phrase);
        const then = ({data}) => {
            // put it at the top of the list?
            // or do we just use it by default?
            // I like the idea of using it by default so that there's no scroll list stuff
            props.setPhrase(phrase);
            setShow(false);
            setAllPhrases([]);
            setPhrase("");
        };
        context.runProcessing(request, then, "addStoredMessage");
    }

    //
    //
    const selectMessage = (phr) => {
        // send up to the main form

        console.log("SELECT A PHRASE", phr)

        props.setPhrase(phr);
        setShow(false);
        setAllPhrases([]);
    }

    //
    //
    const updateMessage = (oldPhrase, newPhrase, callback) => {
        console.log("UPDATE", oldPhrase, newPhrase);
        const request = () => updateStoredMessage(oldPhrase, newPhrase);
        const then = ({data}) => {
            const copy = allPhrases.map(v => {
                if(v.phrase === oldPhrase){
                    v.phrase = newPhrase;
                }
                return v;
            });

            console.log("COPY", copy);

            setAllPhrases(copy);
            callback();
        };
        context.runProcessing(request, then, "updateStoredMessage");
    }

    //
    //
    const deleteMessage = (phr) => {
        const request = () => deleteStoredMessage(phr);
        const then = ({data}) => {
            const copy = [];
            allPhrases.forEach(v => {
                if(v.phrase !== phr){
                    copy.push(v);
                }
            });
            setAllPhrases(copy);
        };
        context.runProcessing(request, then, "deleteStoredMessage");
    }

    return (
        <>
        <div>
        {
            // button to toggle the modal
            <button 
                type="button" 
                className={show ? "option option-on" : "option"} 
                style={{
                    maxHeight:"38px",
                    display: "flex",
                    alignItems: "center",
                    margin: "2px"
                }} 
                ref={setReferenceElement} onClick={buttonClick}>
            {
                show
                ? "CLOSE"
                : "STORED MESSAGES"
            }    
            </button>
        }
        </div>

        {
            // display a popup of all current stored messages
            show
            ? <div ref={setPopperElement} style={{...styles.popper, zIndex:10}} {...attributes.popper}>
                <div style={{
                    padding: "4px",
                    border: "4px solid var(--purple)",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    maxHeight: "50vh",
                    width: "600px"
                }}>
                    <div style={{
                        width: "100%",
                        display: "grid",
                        gridTemplateColumns: "1fr 4fr 1fr",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <span style={{fontWeight:"bold"}}>Current:</span> 
                        <textarea value={phrase} onChange={typePhrase}></textarea>
                        <div className="option" onClick={saveMessage}>Save</div>
                    </div>
                    <div style={{fontWeight: "bold"}}>
                        Click Message Text To Set As Current
                    </div>
                    <div style={{overflow: "auto", width: "584px"}}>
                    {
                        // list of all such stored messages
                        allPhrases.map((v, index) => {
                            return <StoredMessageData 
                                        key={v.phrase} 
                                        display={v.phrase} 
                                        select={selectMessage}
                                        update={updateMessage} 
                                        delete={deleteMessage} 
                                    />
                        })
                    }
                    </div>
                </div>
            </div>
            : null
        }
        </>
    );
};

export default StoredMessagesModal;
